import { QuestionType, QuestionTypes } from '../../../../types/GlobalTypes';

export const checkIfAnswerMessagesRequired = (questionType: QuestionType) => {
  return questionType === QuestionTypes.CLOSED || questionType === QuestionTypes.OPEN_SHORT_TEXT;
};
